<template>
  <div>
    <v-card
      elevation="1"
      color="#FFF"
    >
      <v-card-title>
        <p class="process-header">
          Review Details
        </p>
      </v-card-title>
      <v-card-text>
        <p
          v-if="selectedOrgProject.name"
          class="title-text-style"
        >
          Project: <font class="value-text-style">
            {{ selectedOrgProject.name }}
          </font>
        </p>
        <p
          v-else
          class="title-text-style"
        >
          Project: <font class="value-text-style">
            {{ previousCheckInDetails.project.name }}
          </font>
        </p>
        <p
          v-if="selectedOrgProjectGate.name"
          class="title-text-style"
        >
          Check-in Gate: <font class="value-text-style">
            {{ selectedOrgProjectGate.name }}
          </font>
        </p>
        <p
          v-else
          class="title-text-style"
        >
          Check-in Gate: <font class="value-text-style">
            {{ previousCheckInDetails.checkin_gate.name }}
          </font>
        </p>
        <p class="title-text-style">
          Purpose of Visit:
          <font
            v-if="visitPurpose.visit_purpose !== null"
            class="value-text-style"
          >
            {{ visitPurpose.visit_purpose }}
          </font>
          <font
            v-else
            class="value-text-style"
          >
            N/A
          </font>
        </p>
      </v-card-text>
    </v-card>
    <v-btn
      color="#000"
      class="mt-5 btn-style"
      elevation="0"
      @click="checkIn()"
    >
      Check-in
    </v-btn>
    <v-btn
      light
      color="#E6E6E6"
      class="mt-3 btn-style"
      elevation="0"
      @click="cancel()"
    >
      Cancel
    </v-btn>
    <centre-spinner :loading="loading" />
  </div>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
import Constants from 'src/constants';
import moment from 'moment';

export default {
  name: 'ReviewVisitDetails',
  components: {
    'centre-spinner': spinner,
  },
  data: () => ({
    loading: false,
    cardBgImg: require('@/assets/img/cardBg.png'),
    location: 'NSW Tafe',
    checkInType: 'Visitor',
  }),
  computed: {
    previousCheckInDetails () {
        return this.$store.getters['swiftuser/getPreviousCheckInDetails'];
      },
    visitPurpose () {
      return this.$store.getters['swiftuser/getVisitPurpose'];
    },
    selectedAnswers () {
      return this.$store.getters['questions/getUserSelectedAnswers'];
    },
    checkInId () {
      return this.$store.getters['swiftuser/getCheckInId'];
    },
    locationName () {
      return this.$store.getters['swiftuser/getLocationName'];
    },
    checkInMethodType () {
      return this.$store.getters['swiftuser/getCheckInMethodType'];
    },
    selectedOrganization () {
      return this.$store.getters['organization/getSelectedOrganization'];
    },
    selectedOrgProject () {
      return this.$store.getters['projects/getSelectedOrgProject'];
    },
    selectedOrgProjectGate () {
      return this.$store.getters['projects/getSelectedOrgProjectGate'];
    },
  },
  methods: {
    checkIn () {
      this.loading = true;
      const siteId = this.$route.params.siteId;
      this.$store.dispatch('swiftuser/checkInUser', {
        orgExtId: this.selectedOrganization.organization.external_id,
        details: {
          checkin_time: moment.utc().format(),
          location_id: siteId,
          type: 'visitor',
          checkin_method_type: this.checkInMethodType,
        },
      }).then(response => {
        this.completeCheckInProcess();
      }).catch(errors => {
        this.loading = false;
      });
    },
    async completeCheckInProcess () {
      const selectedAnswers = [];
      selectedAnswers.push({
        answers: this.selectedAnswers,
      });
      await this.$store.dispatch('questions/sendUserSelectedAnswers', {
        answers: selectedAnswers[0],
        checkInId: this.checkInId.id,
      }).then(response => {
        this.$store.dispatch('swiftuser/sendVisitDetails', {
          purpose: {
            purpose_of_visit: this.visitPurpose.visit_purpose,
          },
          checkInId: this.checkInId.id,
        }).then(response => {
          this.loading = false;
          this.$store.dispatch('alert/onAlert', {
            message: 'Check-in completed successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          const checkInId = this.checkInId.id;
          localStorage.setItem('checkIn', checkInId);
          this.$emit('checkin-completed');
        }).catch(() => {
          this.loading = false;
        });
      }).catch(() => {
        this.loading = false;
      });
    },
    cancel () {
      this.loading = true;
      localStorage.removeItem('siteId');
      localStorage.removeItem('scannedTime');
      setTimeout(() => {
        this.$router.push({ name: 'CheckIn' });
      }, 1000);
    },
  },
};
</script>
<style scoped>
#title-text {
  font-weight: bold;
  margin-bottom: 5px;
}
</style>
